export const formatNossoNumero = (nossoNumero) => {
  if (nossoNumero !== null && nossoNumero !== undefined) {
    return `${nossoNumero}`.padStart(9, '0');
  }
  return ``;
};

/*
RNE-297 - Comando "Excluir" - C.R. : Public <<Functional>> Feature
O usuário poderá excluir apenas contas abertas.
Portanto, o comando "Excluir" não será exibido nas ações gerais do grid e nem
na linha do registro quando a situação selecionada no filtro for igual a "Baixada" ou "Excluída".
*/
const verificarExibicaoBotaoExcluir = (tipoSelecao, selecionados) => {
  return (
    tipoSelecao === 'TODOS_FILTRO' ||
    (selecionados && selecionados.length > 0 && !selecionados.every((cp) => cp.situacao !== 'ABERTA'))
  );
};

/*
RNE-298 - Comando "Cancelar baixa" - C.R. : Public <<Functional>> Feature
O usuário poderá cancelar baixa apenas de contas baixadas manualmente.
Portanto, o comando "Cancelar baixa" não será exibido na linha do grid,
nem nas ações gerais do grid e nem nas ações da visualização quando a situação selecionada no filtro for igual a "Aberta" ou "Excluída".

Quando o usuário acionar para cancelar uma baixa, o sistema deve retornar a situação da despesa para "Aberta".

Quando o usuário selecionar pelo menos uma conta baixada por arquivo retorno,
o sistema desabilita o comando "Cancelar baixa" e exibe a mensagem MSG-102 em um hint quando o usuário passar o mouse em cima do comando.
*/
const verificarExibicaoBotaoCancelarBaixa = (tipoSelecao, selecionados) => {
  return (
    tipoSelecao === 'TODOS_FILTRO' ||
    (selecionados &&
      selecionados.length > 0 &&
      !selecionados.every((cp) => cp.situacao !== 'BAIXADA' && cp.situacao !== 'PARCIAL'))
  );
};

/*
RNE-300 - Comando "Baixar" - C.R. : Public <<Functional>> Feature

O usuário poderá baixar apenas contas abertas. Portanto, o comando "Baixar" não será exibido nas
ações gerais do grid, nem na linha do registro e nem na visualização quando a situação selecionada
no filtro for igual a "Baixada" ou "Excluída".

Observação: Quando a conta estiver aberta mas com a caixa de seleção "Conta a receber em sub judice"
marcada, o sistema também não deve exibir a opção de baixa.
*/
const verificarExibicaoBotaoBaixar = (tipoSelecao, selecionados) => {
  return (
    tipoSelecao === 'TODOS_FILTRO' ||
    (selecionados &&
      selecionados.length > 0 &&
      !selecionados.every((cp) => cp.situacao !== 'ABERTA' && cp.situacao !== 'PARCIAL') &&
      selecionados.every((cp) => !cp.subJudice))
  );
};

const verificarPodeExcluir = (selecionados) => {
  return selecionados && selecionados.length > 0 && selecionados.every((cp) => cp.situacao === 'ABERTA');
};

const verificarPodeCancelarBaixa = (selecionados) => {
  return (
    selecionados &&
    selecionados.length > 0 &&
    selecionados.every((cp) => cp.situacao === 'BAIXADA' || cp.situacao === 'PARCIAL')
  );
};

const verificarBaixaConciliada = (selecionados) => {
  if (!selecionados || selecionados.length === 0) {
    return false;
  }

  const temConciliado = selecionados.some((cp) => cp.conciliado === true);
  if (temConciliado) {
    return true;
  }

  return selecionados.some((cp) => cp.lancamentoExtrato && (cp.lancamentoExtrato.id || cp.lancamentoExtrato));
};

const verificarContasOrigensDistintas = (selecionados) => {
  if (!selecionados || selecionados.length <= 1) {
    return false;
  }
  const temConciliada = selecionados.some(
    (cp) => cp.conciliado === true || (cp.lancamentoExtrato && (cp.lancamentoExtrato.id || cp.lancamentoExtrato))
  );
  const temNaoConciliada = selecionados.some(
    (cp) => cp.conciliado !== true && (!cp.lancamentoExtrato || (!cp.lancamentoExtrato.id && !cp.lancamentoExtrato))
  );
  return temConciliada && temNaoConciliada;
};

const verificarTodasContasOrigemConciliacao = (selecionados) => {
  if (!selecionados || selecionados.length === 0) {
    return false;
  }
  return selecionados.every((cp) => cp.origemLancamento === 'CONCILIACAO');
};

const verificarPodeBaixar = (selecionados) => {
  if (!selecionados || selecionados.length === 0) {
    return false;
  }
  const todasAbertas = selecionados.every((cp) => cp.situacao === 'ABERTA');
  const temParcial = selecionados.some((cp) => cp.situacao === 'PARCIAL');

  if (todasAbertas) {
    return true;
  }
  if (temParcial && selecionados.length === 1) {
    return true;
  }
  return false;
};

const possuiAbertasSelecioandas = (selecionados) => {
  return selecionados && selecionados.length > 0 && selecionados.filter((cp) => cp.situacao === 'ABERTA').length > 0;
};

const apenasUmaSituacao = (contasReceber) => {
  return (
    contasReceber &&
    contasReceber.length > 0 &&
    (contasReceber.every((cp) => cp.situacao === 'ABERTA') ||
      contasReceber.every((cp) => cp.situacao === 'BAIXADA') ||
      contasReceber.every((cp) => cp.situacao === 'EXCLUIDA') ||
      contasReceber.every((cp) => cp.situacao === 'AGENDADA'))
  );
};

export const ContasReceberUtil = {
  verificarExibicaoBotaoExcluir,
  verificarExibicaoBotaoCancelarBaixa,
  verificarExibicaoBotaoBaixar,
  verificarPodeExcluir,
  verificarPodeCancelarBaixa,
  verificarBaixaConciliada,
  verificarContasOrigensDistintas,
  verificarTodasContasOrigemConciliacao,
  verificarPodeBaixar,
  apenasUmaSituacao,
  possuiAbertasSelecioandas,
};
